import { render, staticRenderFns } from "./more_details_svg.vue?vue&type=template&id=98645df6&scoped=true&"
import script from "./more_details_svg.vue?vue&type=script&lang=js&"
export * from "./more_details_svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98645df6",
  null
  
)

export default component.exports